function getFeaturedDealsFields() {
  return {
    root: [
      'id',
      'unparse_address',
      'property_sub_type',
      'address',
      'Media',
      'state_or_province',
      'postal_code',
      'city',
      'bedrooms_total',
      'bathrooms_total_decimal',
      'living_area',
      'close_price',
      'deal_rank',
      'list_price',
      'standard_status'
    ].join(','),
  };
}



module.exports = { getFeaturedDealsFields };